/** Joins class names, skipping falsy entries: cn("a", cond && "b", className). */
export const cn = (...classes) => classes.filter(Boolean).join(" ");
